import { render, staticRenderFns } from "./InSwitchLEDNew.vue?vue&type=template&id=180a14f4&scoped=true&"
import script from "./InSwitchLEDNew.vue?vue&type=script&lang=js&"
export * from "./InSwitchLEDNew.vue?vue&type=script&lang=js&"
import style0 from "./InSwitchLEDNew.vue?vue&type=style&index=0&id=180a14f4&lang=scss&scoped=true&"
import style1 from "./InSwitchLEDNew.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180a14f4",
  null
  
)

export default component.exports